// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gaSmH","right":"styles_right__2IBd9"};